import React, {Component} from "react"
import {Link} from "react-router-dom"
import {Button} from "semantic-ui-react"

import Sidebar from "components/Sidebar/Sidebar"
import CartMini from "components/Cart/CartMini"
import app from "app.controller"
import NavigationSidebar from "components/Navigation/NavigationSidebar"
import OrderlistSelection from "components/Orderlist/OrderlistSelection"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import shop from "shop/shop"

import "style/util.scss"
import "./PageLayout.scss"

class PageLayout extends Component {

  render() {
    return (
      <div className="PageLayout">
        <OrderlistSelection/>

        {/*SHOPPING CART*/}
        <Sidebar open={app.sidebar.open}
                 toggle={app.sidebar.toggle}
                 close={app.sidebar.close}>
          <CartMini/>
          {/* TO CART */}


        </Sidebar>

        <Sidebar
          left
          open={app.sidebarLeft.open}
          toggle={app.sidebarLeft.toggle}
          close={app.sidebarLeft.close}
        >
          <SidebarLeft/>

        </Sidebar>
        <Header/>
        <div className="page-content min-vh-100">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    )
  }
}

const SidebarLeft = () => {
  return (
    <div className="SidebarLeft h-100 flex flex-column">
      <div className="bg-silver">
        <div className="pa3 home-logo">
          <Link to="/" onClick={app.sidebarLeft.toggle.dispatch}>
            <img
              onLoad={(event) => {
                event.target.width /=2
              }}
              src={shop.config.logo ? shop.config.logo : undefined}
              alt="zur Startseite"/>
          </Link>
          <Button floated="right" icon="close" onClick={app.sidebarLeft.toggle.dispatch}/>
        </div>
      </div>
      <NavigationSidebar showTitle={false}/>
    </div>
  )
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/theme/oehme/layout/PageLayout.js